import { InventoryReservation } from "./inventory-reservation";

export interface Cargo {
  cargoReference: string;
  orderReference: string;
  clientName: string;
  clientCpf: string;
  cep: string;
  neighborhood: string;
  additionalInformation: string;
  propertyNumber: string;
  street: string;
  referencePoint: string;
  city: string;
  federalUnit: string;
  cargoItems: CargoItem[];
}

export interface CargoItem {
  itemReference: string;
  productReference: string;
  eanCode: string;
  productDescription?: string;
  totalAmount: number;
  invoiced?: boolean;
  batches?: CargoItemBatch[];
}

export interface CargoItemBatch {
  itemReference: string;
  batchReference: string;
  batch: string;
  amount: number;
}

export interface NormalizedCargo {
  id?: number;
  reference: string;
  orderReference: string;
  clientName: string;
  clientCpf: string;
  cep: string;
  neighborhood?: string;
  additionalInformation?: string;
  propertyNumber?: string;
  street?: string;
  referencePoint?: string;
  city?: string;
  federalUnit?: string;
  cargoItems: NormalizedCargoItem[];
  date?: string;
  route?: Route;
  status?: "NOT_CHECKED" | "PENDING" | "CHECKED";
  checkedAt?: string;
  warehouseId: number;
}

export interface NormalizedCargoItem {
  id?: number;
  cargoId?: number;
  reference: string;
  productReference: string;
  eanCode: string;
  productDescription?: string;
  invoiced?: boolean;
  batchReference?: string;
  batch?: string;
  amount: number;
  packageAmount?: number;
  separatedAmount?: number;
  inventoryReservations?: InventoryReservation[];
}

export enum Route {
  saoMateus = "SAO_MATEUS",
  linhares = "LINHARES",
  teixeira = "TEIXEIRA",
  interior = "INTERIOR",
}
